import React from "react";

import { useQueryString } from "app/context";

import FilterTag from "components/common/FilterTag";

const EntityFilterState = ({ children, entities, queryKey }) => {
  const { queryString, onToggleQueryStringValue } = useQueryString();

  if (!queryString[queryKey]) {
    return null;
  }

  const activeEntities = queryString[queryKey].filter(
    entityId => Object.prototype.hasOwnProperty.call(entities, entityId)
  );

  return (
    <>
      {activeEntities.map(entityId => (
        <FilterTag
          key={entityId}
          label={entities[entityId].name}
          onRemove={() => onToggleQueryStringValue(queryKey, entityId)}
        >
          {children && children(entityId)}
        </FilterTag>
      ))}
    </>
  );
};

export default EntityFilterState;
